import { fade, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  header: {
    boxShadow: `0px 0px 6px ${fade(theme.palette.common.black, 0.1)}`,
    transition: 'all 0.5s ease-in-out',
    '&.MuiAppBar-root': {
      backgroundColor: theme.palette.common.white,
      '&.inverse-Header': {
        backgroundColor: theme.palette.common.white,
        '& $headerDesktop': {
          alignItems: 'center'
        }
      }
    },
    '&.shrink': {
      padding: theme.spacing(0)
    }
  },
  headerToolbar: {
    minHeight: theme.spacing(8),
    padding: theme.spacing(1.5, 1),
    transition: 'all 0.5s ease-in-out',
    '.shrink &': {
      padding: theme.spacing(0.75, 1)
    },
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(0)}px !important`
    }
  },
  headerDesktop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexGrow: 1
  },
  headerTitle: {
    color: theme.palette.primary.dark,
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightBold
  },
  headerGridContainer: {
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap'
    }
  },
  mobileView: {},
  userMenuWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  headerLinksWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    marginRight: theme.spacing(2.5),
    paddingRight: theme.spacing(2),
    '&:after': {
      content: '""',
      width: 1,
      height: 50,
      backgroundColor: theme.palette.colors.border,
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translate(0, -50%)'

    }
  }
}))
